module.exports = __webpack_public_path__ + "static/media/usina-eplast2.0d5bc8f8.png";